import { createClient, FindOperation, getRequestFactory, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { Cdr } from './model';

export interface ResendCdrCommand {
  cdrIds: string[];
}

const client = createClient('/rest/cdrs');

export const cdrsPermissions = {
  GET: 'cpms.get-cdr',
  RESEND: 'cpms.resend-cdr'
};

export const getCdr: FindOperation<Cdr, string> = getRequestFactory<Cdr, string>(client, {
  permissionId: cdrsPermissions.GET
});

export const resendCdrs: SaveOperation<ResendCdrCommand, never> = postRequestFactory<ResendCdrCommand, never>(client, {
  pattern: '/resend',
  permissionId: cdrsPermissions.RESEND
});
